import { jwtDecode } from "jwt-decode";

export const loggedInUserId = () => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const userId = decoded.userId;
    return { userId };
}